// Stable per-browser device ID used for advisor trust + click de-dupe.
// Generated once, then persisted in localStorage.
const KEY = "propertic_device_id";
const LABEL_KEY = "propertic_device_label";
const SESSION_KEY = "propertic_session_id";

function _uuid() {
  if (typeof crypto !== "undefined" && crypto.randomUUID) return crypto.randomUUID();
  return "dev-" + Math.random().toString(36).slice(2) + Date.now().toString(36);
}

export function getDeviceId() {
  try {
    let id = localStorage.getItem(KEY);
    if (!id) {
      id = _uuid();
      localStorage.setItem(KEY, id);
    }
    return id;
  } catch {
    return "unknown";
  }
}

export function getSessionId() {
  // 30-day rolling identifier stored in localStorage.
  // Previous implementation was per-tab (evicted on close), which caused
  // analytics unique-visitor inflation — every incognito visit, every
  // hard refresh, every new tab counted as a brand-new "unique" user.
  // localStorage keeps the same id across tabs + refreshes on the same
  // device; the 30-day expiry aligns with how GA4/Plausible/Fathom bucket
  // "unique visitors" so the CRM number stays comparable to industry norms.
  const TTL_MS = 30 * 24 * 60 * 60 * 1000; // 30 days
  const STAMP_KEY = "propertic_session_stamp";
  try {
    const now = Date.now();
    const cachedId = localStorage.getItem(SESSION_KEY);
    const cachedStamp = parseInt(localStorage.getItem(STAMP_KEY) || "0", 10);
    if (cachedId && cachedStamp && (now - cachedStamp) < TTL_MS) {
      return cachedId;
    }
    const id = _uuid();
    localStorage.setItem(SESSION_KEY, id);
    localStorage.setItem(STAMP_KEY, String(now));
    return id;
  } catch {
    return "session-" + Date.now();
  }
}

// One visit = activity with no gap longer than 30 min (GA-style). Every call refreshes the timer.
export function getVisitId() {
  const IDLE_MS = 30 * 60 * 1000;
  const ID_KEY = "propertic_visit_id";
  const LAST_KEY = "propertic_visit_last";
  try {
    const now = Date.now();
    let id = localStorage.getItem(ID_KEY);
    const last = parseInt(localStorage.getItem(LAST_KEY) || "0", 10);
    if (!id || !last || now - last > IDLE_MS) {
      id = "v-" + _uuid();
      localStorage.setItem(ID_KEY, id);
    }
    localStorage.setItem(LAST_KEY, String(now));
    return id;
  } catch {
    return null;
  }
}


export function getDeviceLabel() {
  try {
    const cached = localStorage.getItem(LABEL_KEY);
    if (cached) return cached;
  } catch {}
  const ua = (navigator.userAgent || "").toLowerCase();
  let os = "Unknown";
  if (/iphone|ipad|ipod/.test(ua)) os = "iPhone";
  else if (/android/.test(ua)) os = "Android";
  else if (/macintosh|mac os x/.test(ua)) os = "Mac";
  else if (/windows/.test(ua)) os = "Windows";
  else if (/linux/.test(ua)) os = "Linux";
  let browser = "Browser";
  if (/edg\//.test(ua)) browser = "Edge";
  else if (/chrome\//.test(ua) && !/edg\//.test(ua)) browser = "Chrome";
  else if (/safari\//.test(ua) && !/chrome\//.test(ua)) browser = "Safari";
  else if (/firefox\//.test(ua)) browser = "Firefox";
  const label = `${os} · ${browser}`;
  try { localStorage.setItem(LABEL_KEY, label); } catch {}
  return label;
}
